export const dispatchReportKeys = {
    all: () => ['dispatch-report'] as const,
    report: (reportDate: string) => ['dispatch-report', 'report', reportDate] as const,
}
